import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Table state for the Un-Invited Participants card on the session Assessment Status tab.
// Kept separate from sessionParticipantDatesTableState so filters/sorts set on the
// Registrations (Dates) grid can't leak into (and hide rows from) the card.

// Define a type for the slice state
export interface sessionUninvitedParticipantsTableStateState {
    TableState: string;
}

// Define the initial state using that type
const initialState: sessionUninvitedParticipantsTableStateState = {
    TableState: JSON.stringify({
        sorting: {
            sortModel: [{ field: "name", sort: "asc" }],
        },
        columns: {
            columnVisibilityModel: {
                attendance: false,
                registrationStatus: true,
                name: true,
                firstName: false,
                lastName: false,
                emailAddress: true,
                registrationDate: true,
                preferredLanguage: true,
                scheduledPreworkInvitation: true,
                actualPreworkInvitation: true,
                deadline: true,
                accessExpiration: true,
            },
        },
    }),
};

export const sessionUninvitedParticipantsTableStateSlice = createSlice({
    name: "sessionUninvitedParticipantsTableState",
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        updateSessionUninvitedParticipantsGridState: (
            state,
            action: PayloadAction<string | null>,
        ) => {
            state.TableState = action?.payload ?? initialState.TableState;
        },
    },
});

export const { updateSessionUninvitedParticipantsGridState } =
    sessionUninvitedParticipantsTableStateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const sessionUninvitedParticipantsTableState = (state: RootState) => state;
export default sessionUninvitedParticipantsTableStateSlice.reducer;
